import {Base} from "@/api/Base"

export class DepartmentAdd extends Base {
    path = "department/add"
}